import { Components, Theme } from '@mui/material';

const muiSelect: Components<Theme>['MuiSelect'] = {
	styleOverrides: {
		root: {
			variants: [
				{
					props: { size: 'small' },
					style: { height: '44px' },
				},
			],
		},
		select: ({ theme }) => ({
			'&:focus': {
				backgroundColor: theme.palette.background.default,
			},
		}),
	},
};

export default muiSelect;
